module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/desktop/dashkit-alt-ceabb996193836663c8e583e5e801a0e.jpg";